import { render, staticRenderFns } from "./systemCoupon.vue?vue&type=template&id=df4a6080&"
import script from "./systemCoupon.vue?vue&type=script&lang=js&"
export * from "./systemCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports